var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[(_vm.isLoggedIn)?_c('NavBar'):_vm._e(),_c('SnackBar',_vm._b({},'SnackBar',_vm.snackbarDisplay,false)),_c('vue-confirm-dialog'),_c('v-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }